<template>

    <div class="sexy-santa-banner">

        <div class="container">

            <div class="row">
                <div class="col-12 sexy-santa-banner-content-wrapper d-flex">

                    <div class="sexy-santa-banner-image">
                        <img src="/images/sexy-santa/sexy-santa-banner.png">
                    </div>

                    <div class="sexy-santa-banner-content d-flex text-white">

                        <div class="sexy-santa-banner-text px-0 px-sm-4">
                            <div class="sexy-santa-banner-title">{{ translate.home.sexySanta.title }}</div>
                            <div class="sexy-santa-banner-description">
                                {{ translate.home.sexySanta.bannerText }} <strong>400€!</strong>
                            </div>
                        </div>

                        <div class="sexy-santa-banner-button mb-3 mb-sm-0 mt-2">
                            <a :href="regionRelativeUrl('/sexy-santa/')" class="btn btn-white btn-small px-5 px-sm-4">
                                {{ translate.home.sexySanta.enter }}
                            </a>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

const data = () => {
    return {
        store: $store,
    }
}

function mounted() {
    this.store.commit('setSexySantaBannerIsVisible', true);
}

function beforeDestroy() {
    this.store.commit('setSexySantaBannerIsVisible', false);

}

export default {
    data,
    mounted,
    computed: {
        ...mapState(['translate'])
    },
    mixins:[
        regionsUrlMixin,
    ],
    beforeDestroy,
}
</script>
